import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#0F1012] flex items-center justify-center px-6" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-sm"
      >
        <div className="flex justify-center mb-10">
          <Logo />
        </div>
        <form onSubmit={submit} className="gold-border bg-[#1E2128] p-8 space-y-4" data-testid="admin-login-form">
          <p className="font-mono-lux text-[10px] uppercase tracking-[0.35em] text-amber-500 flex items-center gap-2">
            <Lock size={12} /> Concierge Access
          </p>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="w-full bg-[#0F1012] border border-zinc-800 focus:border-amber-500/60 outline-none px-4 py-3.5 text-sm text-zinc-200 placeholder:text-zinc-600 transition-colors"
            data-testid="admin-email-input"
          />
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full bg-[#0F1012] border border-zinc-800 focus:border-amber-500/60 outline-none px-4 py-3.5 text-sm text-zinc-200 placeholder:text-zinc-600 transition-colors"
            data-testid="admin-password-input"
          />
          {error && (
            <p className="text-xs text-red-400" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full font-mono-lux text-[11px] uppercase tracking-[0.3em] py-4 bg-amber-500 text-black hover:bg-amber-300 disabled:opacity-50 transition-colors"
          >
            {loading ? "Entering…" : "Enter the House"}
          </button>
        </form>
        <p className="text-center mt-6">
          <Link to="/" className="font-mono-lux text-[10px] uppercase tracking-[0.3em] text-zinc-600 hover:text-amber-400 transition-colors">
            ← Return to site
          </Link>
        </p>
      </motion.div>
    </main>
  );
}
